export default __webpack_public_path__ + "static/media/4.65dc0a0a.png";